import EditorJS from '@editorjs/editorjs';
import { InstructionCSSClasses, InstructionEvent } from '../types';
import {
  emitInstructionEventByEditor,
  getInstructionFromSpan,
  removeInlineInstructionWrapper,
  renderExclamationIcon
} from '../utils';
import { detectIOS } from '../../../../utility/helpers';

export const addEventListenerToImageActions = async (
  params: {
    instanceEditor: EditorJS;
    refEditor: HTMLDivElement;
  },
) => {
  const { instanceEditor, refEditor } = params;

  const actionHandler = (event: MouseEvent | TouchEvent) => {
    const mappedTarget = event.target as HTMLSpanElement;
    const instructionId = getInstructionFromSpan(mappedTarget as HTMLSpanElement);
    if (instructionId) {
      emitInstructionEventByEditor(
        instanceEditor,
        InstructionEvent.OPEN_IMAGE_INSTRUCTION_MODAL,
        {
          instructionId,
          isInline: true,
        },
      );
    }
  };

  instanceEditor.isReady.then(() => {
    const actions = refEditor.querySelectorAll<HTMLSpanElement>(
      `.${InstructionCSSClasses.IMAGE_INSTRUCTION_ACTION}`,
    );
    actions.forEach((item) => {
      const instructionId = getInstructionFromSpan(item);
      if (instructionId) {
        renderExclamationIcon(item, instructionId);
        if (item.parentElement) {
          removeInlineInstructionWrapper(item.parentElement);
        }
      }
      if (detectIOS()) {
        // eslint-disable-next-line
        item.onmouseenter = actionHandler;
      }
      // eslint-disable-next-line
      item.onclick = actionHandler;
    });
  });
};
